import { useNavigate, useLocation, useSearchParams as useReactRouterSearchParams } from 'react-router-dom';

export const useRouter = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return {
    push: (path: string) => navigate(path),
    replace: (path: string) => navigate(path, { replace: true }),
    back: () => navigate(-1),
    pathname: location.pathname,
    search: location.search,
    hash: location.hash,
  };
};

export const usePathname = () => {
  const location = useLocation();
  return location.pathname;
};

export const useSearchParams = () => {
  const [searchParams, setSearchParams] = useReactRouterSearchParams();

  return {
    get: (key: string) => searchParams.get(key),
    set: (key: string, value: string) => {
      searchParams.set(key, value);
      setSearchParams(searchParams);
    },
    searchParams,
    setSearchParams,
  };
};
